module.exports = __webpack_public_path__ + "img/87.bb1208ef.jpg";